import { StorageConstant } from "constants/CommonConstants";
import { differenceInSeconds } from "date-fns";
import { getItemFromStorage, removeItemFromStorage, setItemToStorage } from "./storageHelper";
import { BID_PRICE_TYPE } from "./constant";
export const convertHexToRGB = (hex) => {
  // check if it's a rgba
  if (hex.match("rgba")) {
    let triplet = hex.slice(5).split(",").slice(0, -1).join(",");
    return triplet;
  }

  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = "0x" + c.join("");

    return [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",");
  }
};

function currentYPosition(elm) {
  if (!window && !elm) return;

  if (elm) return elm.scrollTop;
  // Firefox, Chrome, Opera, Safari
  if (window.pageYOffset) return window.pageYOffset;
  // Internet Explorer 6 - standards mode
  if (document.documentElement && document.documentElement.scrollTop)
    return document.documentElement.scrollTop;
  // Internet Explorer 6, 7 and 8
  if (document.body.scrollTop) return document.body.scrollTop;
  return 0;
}

function elmYPosition(elm) {
  var y = elm.offsetTop;
  var node = elm;
  while (node.offsetParent && node.offsetParent !== document.body) {
    node = node.offsetParent;
    y += node.offsetTop;
  }
  return y;
}

export function scrollTo(scrollableElement, elmID) {
  var elm = document.getElementById(elmID);

  if (!elmID || !elm) {
    return;
  }

  var startY = currentYPosition(scrollableElement);
  var stopY = elmYPosition(elm);

  var distance = stopY > startY ? stopY - startY : startY - stopY;
  if (distance < 100) {
    scrollTo(0, stopY);
    return;
  }
  var speed = Math.round(distance / 50);
  if (speed >= 20) speed = 20;
  var step = Math.round(distance / 25);
  var leapY = stopY > startY ? startY + step : startY - step;
  var timer = 0;
  if (stopY > startY) {
    for (var i = startY; i < stopY; i += step) {
      setTimeout(
        (function (leapY) {
          return () => {
            scrollableElement.scrollTo(0, leapY);
          };
        })(leapY),
        timer * speed
      );
      leapY += step;
      if (leapY > stopY) leapY = stopY;
      timer++;
    }
    return;
  }
  for (let i = startY; i > stopY; i -= step) {
    setTimeout(
      (function (leapY) {
        return () => {
          scrollableElement.scrollTo(0, leapY);
        };
      })(leapY),
      timer * speed
    );
    leapY -= step;
    if (leapY < stopY) leapY = stopY;
    timer++;
  }
  return false;
}

export function getTimeDifference(date) {
  let difference = differenceInSeconds(new Date(), date);

  if (difference < 60) return `${Math.floor(difference)} sec`;
  else if (difference < 3600) return `${Math.floor(difference / 60)} min`;
  else if (difference < 86400) return `${Math.floor(difference / 3660)} h`;
  else if (difference < 86400 * 30) return `${Math.floor(difference / 86400)} d`;
  else if (difference < 86400 * 30 * 12) return `${Math.floor(difference / 86400 / 30)} mon`;
  else return `${(difference / 86400 / 30 / 12).toFixed(1)} y`;
}


export function isJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}



export function persistAuthData(data) {
  setItemToStorage(StorageConstant?.is_admin_access_token, data?.tokens?.access?.token);
  setItemToStorage(StorageConstant?.is_admin_refresh_token, data?.tokens?.refresh?.token);
  setItemToStorage(StorageConstant?.user_email, data?.user?.user_email);
  setItemToStorage(StorageConstant?.user_name, data?.user?.user_name);

}

export function persistAuthFlow(flow, key, value) {
  setItemToStorage(StorageConstant?.flow, flow);
  setItemToStorage(key, value);


}

export function clearAuthData() {
  removeItemFromStorage(StorageConstant?.is_admin_access_token);
  removeItemFromStorage(StorageConstant?.is_admin_refresh_token);
  removeItemFromStorage(StorageConstant?.user_email);
  removeItemFromStorage(StorageConstant?.user_name);

}


// Function to pluralize entity name
export function pluralize(word) {
  if (!word || typeof word !== 'string') {
    throw new Error('Input must be a non-empty string');
  }

  // Regular expressions for common pluralization rules
  const pluralRules = [
    [/(m)an$/i, '$1en'],
    [/(pe)rson$/i, '$1ople'],
    [/(child)$/i, '$1ren'],
    [/(foot)$/i, 'feet'],
    [/(tooth)$/i, 'teeth'],
    [/(goose)$/i, 'geese'],
    [/(mouse)$/i, 'mice'],
    [/(ox)$/i, '$1en'],
    [/(quiz)$/i, '$1zes'],
    [/(s|x|z|ch|sh)$/i, '$1es'],
    [/([^aeiouy]|qu)y$/i, '$1ies'],
    [/([^f])fe$/i, '$1ves'],
    [/([lr])f$/i, '$1ves'],
    [/(hive)$/i, '$1s'],
    [/([^aeiouy]|qu)y$/i, '$1ies'],
    [/(tive)$/i, '$1s'],
    [/(o)$/i, '$1es'],
    [/(bus)$/i, '$1es'],
    [/(alias|status)$/i, '$1es'],
    [/(octop|vir)us$/i, '$1i'],
    [/(ax|test)is$/i, '$1es'],
    [/(sis)$/i, 'ses'],
    [/$/, 's'] // Default rule (add 's')
  ];

  for (const rule of pluralRules) {
    if (rule[0].test(word)) {
      return word.replace(rule[0], rule[1]);
    }
  }

  return word; // Fallback if no rule matches
}



export function appendToastStatus(data, toastStatus, apiLoading = false) {
  return { ...data, toastStatus, apiLoading };
};


// Helper function to determine PAGE_SIZE_OPTIONS based on count
export function getPageSizeOptions(count) {
  if (count <= 10) {
    return [10];
  } else if (count <= 25) {
    return [10, 25];
  } else if (count <= 50) {
    return [10, 25, 50];
  } else if (count <= 100) {
    return [10, 25, 50, 100];
  } else {
    return [10, 25, 50, 100, 500];
  }
};



export const convertAndFormatPrice = (price, country) => {
  let convertedPrice;
  let currencySymbol;
  let exchangeRate;

  switch (country.toLowerCase()) {
    case 'nigeria':
      currencySymbol = '₦';
      exchangeRate = 460;
      break;
    case 'united kingdom':
      currencySymbol = '£';
      exchangeRate = 0.79;
      break;
    default:
      currencySymbol = '$';
      exchangeRate = 1;
  }

  convertedPrice = Math.round(price * exchangeRate);

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'decimal', // Changed from 'currency' to 'decimal'
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  // Simply combine the currency symbol with the formatted number
  return `${currencySymbol}${formatter.format(convertedPrice)}`;
};

// Currency configuration
const CURRENCY_CONFIG = {
  'Nigeria': {
    symbol: '₦',
    locale: 'en-NG',
    currencyCode: 'NGN'
  },
  'United Kingdom': {
    symbol: '£',
    locale: 'en-GB',
    currencyCode: 'GBP'
  }
};

/**
 * Calculate and format final price based on bidding parameters and country currency
 * @param {boolean} isBiddable - Whether the venue is biddable
 * @param {number} bookingPrice - Original booking price
 * @param {number} bidPriceType - Type of bid (1 for fixed, 2 for percentage)
 * @param {number} fixedBidPrice - Bid amount or percentage
 * @param {string} countryName - Country name for currency formatting
 * @returns {string} Final calculated and formatted price
 */
export const convertAndFormatPriceForBidable = (isBiddable, bookingPrice, countryName, bidPriceType, fixedBidPrice) => {
  let finalPrice = bookingPrice;

  // Calculate price based on bid type
  if (isBiddable) {
    switch (bidPriceType) {
      case BID_PRICE_TYPE.FIXED:
        finalPrice = bookingPrice - fixedBidPrice;
        break;
      case BID_PRICE_TYPE.PERCENTAGE:
        const discount = (bookingPrice * fixedBidPrice) / 100;
        finalPrice = bookingPrice - discount;
        break;
      default:
        break;
    }
  }

  // Format price based on country currency config
  const config = CURRENCY_CONFIG[countryName];
  if (!config) {
    return `${finalPrice}`; // Return unformatted price if country not found
  }

  return new Intl.NumberFormat(config.locale, {
    style: 'currency',
    currency: config.currencyCode,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(finalPrice);
};


export const getAverageRating = (ratings) => {
  if (ratings && ratings) {

    if (!ratings || ratings.length === 0) {
      return 0; // Handle empty array case
    }

    // Calculate the sum of ratings
    const sum = ratings.reduce((total, item) => total + item.rating, 0);

    // Calculate the average
    const average = sum / ratings.length;

    // Round the average to 2 decimal places (optional)
    // return Math.round(average * 100) / 100;

    return parseFloat(average.toFixed(1));

  }

}


export const isLoginChecker = () => {
  return getItemFromStorage(StorageConstant.is_admin_access_token);
}




export function calculateDistance(lat1, lon1, lat2, lon2) {
  const R = 6371; // Radius of the Earth in km
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lon2 - lon1) * (Math.PI / 180);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c; // Distance in km
  return distance;
}

export const formatNumber = (num) => {
  // Handle undefined/null case
  if (!num) return '0';

  const units = ['', 'K', 'M', 'B', 'T'];
  const order = Math.floor(Math.log10(Math.abs(num)) / 3);

  if (order < 0) return num.toString();
  if (order >= units.length) return 'Too large';

  const value = num / Math.pow(10, order * 3);
  return `${value.toFixed(1)}${units[order]}`;
};